import type { PriorityPlaylist } from '@backrs_ui/common-ui';

import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

export const useAgentContext = (playlists: PriorityPlaylist[]) => {
  useRegisterAgentContext({
    kind: 'section',
    title: 'My Playbooks',
    description: 'User-created playbooks with tasks and progress tracking',
  });

  useRegisterAgentContext({
    kind: 'list',
    description: 'User playbooks with progress',
    data: { playlists },
  });
};
